import React from "react";

const Support = () => {
  const pageStyle = {
    backgroundColor: "#222222",
    color: "#ffffff",
    minHeight: "100vh",
    padding: "20px 0"
  };

  const h3Style = {
    fontSize: "1.5em",
    color: "#ffffff",
    marginBottom: "10px",
    marginTop: "20px"
  };

  const containerStyle = {
    maxWidth: "800px",
    margin: "0 auto",
    padding: "0 20px"
  };

  const contactBoxStyle = {
    backgroundColor: "#333333",
    padding: "20px",
    borderRadius: "8px",
    margin: "20px 0",
    border: "1px solid #444444"
  };

  const linkStyle = {
    color: "#f7c054",
    textDecoration: "underline"
  };

  return (
    <div className="page" style={pageStyle}>
      <div className="header">
        <div className="container">
          <p className="title">HH Courses Support</p>
        </div>
      </div>

      <div className="translations-content-container">
        <div className="container" style={containerStyle}>
          <div className="tab-content translations-content-item en visible" id="en">
            <h1>Support & Help Center</h1>
            <p>Welcome to HH Courses Support! We're here to help you with any questions or issues you may have.</p>

            <h2>Contact Information</h2>
            <div style={contactBoxStyle}>
              <h3 style={h3Style}>Email Support</h3>
              <p>
                <strong>Primary Support:</strong>{" "}
                <a href="mailto:hereforthehereafter@gmail.com" style={linkStyle}>
                  hereforthehereafter@gmail.com
                </a>
              </p>
              <p>We typically respond to emails within 24-48 hours.</p>
            </div>

            <h2>How to Get Help</h2>
            <div style={contactBoxStyle}>
              <h3 style={h3Style}>When contacting support, please include:</h3>
              <ul>
                <li>Your account email address</li>
                <li>Device type (iPhone, Android, Web browser)</li>
                <li>Description of the issue</li>
                <li>Steps you've already tried</li>
                <li>Screenshots if applicable</li>
              </ul>
            </div>

            <h2>Privacy & Data</h2>
            <p>
              For information about how we handle your data, please review our{" "}
              <a href="/privacy-policy" style={linkStyle}>
                Privacy Policy
              </a>.
            </p>

            <h2>Website</h2>
            <p>
              Visit our main website:{" "}
              <a href="https://hhcourses.com" target="_blank" rel="noopener noreferrer" style={linkStyle}>
                www.hhcourses.com
              </a>
            </p>
          </div>
        </div>
      </div>

      <div className="footer">
        <div className="container"></div>
      </div>
    </div>
  );
};

export default Support;
